var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customer)?_c('v-container',{staticClass:"px-5 pt-0",attrs:{"id":"call-log-customer-details"}},[_c('h3',{staticClass:"mb-3"},[_vm._v("Customer Details")]),_c('CustomerDetails',{attrs:{"customer":_vm.customer}}),_c('v-row',[_c('v-col',[_c('v-btn',{attrs:{"type":"button","color":"success","outlined":"","block":""},on:{"click":function($event){return _vm.$store.dispatch(
          'openCustomerModalForm',
          {
            customer: {
              CustomerID: _vm.customer.CustomerID,
            },
          },
        )}}},[_vm._v(" Edit Customer ")])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }